import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tran-load-more-files',
    imports: [TranslatePipe],
    templateUrl: './load-more-files.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadMoreFilesComponent {
    public readonly canLoadMore = input<boolean>(false);
    public readonly label = input<string>('common.load-more');
    public readonly loadMore = output<void>();
}
